const codeSelector = rdxState =>
  rdxState && rdxState.codeReducer && rdxState.codeReducer.code;

const codeIsLoadingSelector = rdxState =>
  rdxState && rdxState.codeReducer && rdxState.codeReducer.isLoading;

export default codeSelector;

export { codeSelector, codeIsLoadingSelector };
